<div class="p-2 bg-on-primary rounded-xl">
    <app-expansion-panel>
        <div
            class="flex w-full items-center"
            header>
            <div class="w-full h-full">
                <fa-icon
                    class="text-gray-600 pr-4"
                    size="lg"
                    [icon]="['fad', `${themeIcon()}`]" />
                <span
                    class="text-headline-6 font-medium"
                    [class]="isThemeActive() ? 'text-black' : 'text-custom-dark-grey'"
                    >{{ theme().name }}</span
                >
            </div>

            <div class="gap-3 shrink-0 pr-1.5">
                <app-visibility-button
                    [canToggle]="true"
                    [isGroup]="true"
                    [visibilityButtonState]="visibilityButtonState()"
                    (visibilityToggle)="onVisibilityToggle($event)" />
            </div>
        </div>
        <div content>
            @for (group of groupedSources(); track group[0].name) {
                <app-source-item
                    [canBeEdited]="canBeEdited()"
                    [depositName]="areLayersGrouped() ? null : group[0].depositName"
                    [hasTabView]="hasTabView()"
                    [isDataLayerSource]="true"
                    [isFiltered]="group[0].isFiltered"
                    [isSourceTheme]="true"
                    [sourceType]="SourceTypeEnum.LAYER_SOURCE"
                    [sources]="group"
                    (openTabView)="openLayerInExternalWindow($event, group[0].name)" />
            }
        </div>
    </app-expansion-panel>
</div>
